let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6i2h6")).then(() => parcelRequire('c7xY6'));